import angular from 'angular';

export const dateNow = function ($filter) {
    return {
        link: function ($scope, $element, $attrs) {
            $element.text($filter('date')(new Date(), $attrs.dateNow));
        }
    };
};

angular
    .module('TALENYA-FE')
    .directive('dateNow', dateNow);
